<template>
  <form-capsule :formTitle="$t('webheader.back_office')" :writable="false">
      <template slot="formcontent">
        Workflow document <br/>
        <br/>
      Workflow paiement
    </template>
  </form-capsule>
</template>

<script>
import formCapsule from '@/components/common/formCapsule.vue'

export default {
  components: {
    'form-capsule': formCapsule
  },
  name: 'BackOffice'
}
</script>



// WEBPACK FOOTER //
// BackOffice.vue?e47b4272